var map = {
	"./about/About.vue": [
		598,
		21
	],
	"./archive/Archive.vue": [
		599,
		29
	],
	"./archiveWinners/ArchiveWinners.vue": [
		600,
		16
	],
	"./docs/Docs.vue": [
		601,
		37
	],
	"./home/Home.vue": [
		602,
		9
	],
	"./members/Members.vue": [
		603,
		30
	],
	"./news/News.vue": [
		604,
		4
	],
	"./notFound/NotFound.vue": [
		605,
		39
	],
	"./partners/Partners.vue": [
		606,
		38
	],
	"./votes/Votes.vue": [
		607,
		19
	],
	"./votesForm/VotesForm.vue": [
		608,
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 594;


//////////////////
// WEBPACK FOOTER
// ./src/app2024/pages lazy ^\.\/.*\.vue$
// module id = 594
// module chunks = 41